<template>
  <div class="yxp-uploader">
    <slot name="overTips" />
    <button
      v-if="fileBtn"
      class="btn upload-btn"
      :class="className"
      type="button"
      @click.stop.prevent="handleClick"
    >
      {{ btnName }}
    </button>
    <input
      :id="uploaderId"
      ref="input"
      type="file"
      name="yxpuploader"
      :multiple="multiple"
      :accept="accept"
      :limit="limit"
      :capture="capture"
      @change="handleChange"
    >
    <slot name="underTips" />

    <YxpUploadList
      v-if="showList"
      ref="uploadList"
      :list="fileList"
      @onRemove="handleRemove"
    />
  </div>
</template>

<script>
// { doUpload, uploadProcess, getMd5, getAuth, postFile, getUploadUrl }
import { uploadQuene } from './upload.process.js';
import YxpUploadList from './uploadList.vue';

export default {
    name: 'YxpUpload',
    components: { YxpUploadList },
    props: {
        'uploaderId': {
            type: String,
            required: true,
        },
        'theme': {
            type: String,
            required: false,
            default: '',
        },
        'accept': {
            type: String,
            required: false,
            default: '',
        },
        'limit': {
            type: Number,
            required: false,
            default: 1,
        },
        'btnName': {
            type: String,
            required: false,
            default: '请选择文件',
        },
        'className': {
            type: String,
            required: false,
            default: '',
        },
        'autoUpload': {
            type: Boolean,
            required: false,
            default: false,
        },
        'maxSize': {
            type: Number,
            required: false,
            default: 1024 * 10, // 单位kb
        },
        'showList': {
            type: Boolean,
            required: false,
            default: true,
        },
        'fileList': {
            type: Array,
            required: true,
            default () {
                return [];
            },
        },
        'fileBtn': {
            type: Boolean,
            required: false,
            default: true,
        },
        'uploadModeType': {
            type: String,
            required: false,
            default: '',
        },
        'uploadUrl': {
            type: String,
            required: false,
            default: '',
        },
        // 多媒体动作（json字符串）
        'multimedia': {
            type: String,
            required: false,
            default: '',
        },
        'capture': {
            type: String,
            required: false,
            default: undefined,
        },
        'uploadConfig': {
            type: Array,
            required: false,
            default () {
                return [];
            },
        },
    },
    data () {
        return {
            fails: [],
        };
    },
    computed: {
        multiple () {
            return this.limit > 1;
        },
    },
    mounted () {
        window.yxploadFileList = this.fileList;
    },
    methods: {
        showMaxSize (maxSize) {
            if (maxSize <= 1024) {
                return maxSize + 'KB';
            } else {
                return Math.round(maxSize / 1024).toFixed(1) + 'MB';
            }
        },
        checkType (rawFile) {
            let accept = this.accept.toLowerCase();
            let accept_ = [];
            if (this.uploadConfig.length) {
                this.uploadConfig.map(r => {
                    r.accept && accept_.push(r.accept);
                });
            }
            accept_ && (accept = accept.toString());
            var extName = rawFile.name.substring(rawFile.name.lastIndexOf('.') + 1);
            extName = extName.toLowerCase();

            var s2 = accept.toLowerCase();
            s2 = s2.replace(/(\.|\*|image\/|video\/|audio\/)/ig, '');
            s2 = s2.split(',');

            var s3 = accept_.toString().toLowerCase();
            s3 = s3.replace(/(\.|\*|image\/|video\/|audio\/)/ig, '');
            s3 = s3.split(',');

            if (s2.indexOf(extName) !== -1 || s3.indexOf(extName) !== -1) {
                return true;
            } else {
                console.log(s2, s3, extName);
                return false;
            }
        },
        // 格式化 filelist
        formatFileList (upFiles) {
            var that = this;
            var item;
            let uploadConfig = null;
            let extName = '';
            let auth = true;
            for (var i = 0; i < upFiles.length; i++) {
                item = upFiles[i];
                // 取配置
                extName = item.name.substring(item.name.lastIndexOf('.') + 1);
                uploadConfig = this.uploadConfig.find(r => {
                    let acc = r.accept.toLowerCase();
                    acc = acc.replace(/(\.|\*|image\/|video\/|audio\/)/ig, '');
                    acc = acc.split(',');
                    return acc.includes(extName.toLowerCase());
                });

                // 判断后缀，格式不对报错，并执行下一条
                if (!this.checkType(item)) {
                    let errorTip = '[' + item.name + ']文件格式不对';
                    this.fails.push({ 'status': 'fail', 'errMsg': errorTip, 'errType': 'err_type', file: item });
                    continue;
                }
                // 判断大小，0kb报错，并执行下一条
                if (item.size <= 0) {
                    let errorTip = '空文件，上传失败';
                    this.fileList.push({ rawFile: item, 'status': 'empty', 'errMsg': errorTip, 'errType': 'empty_file', file: item });

                    continue;
                }

                // 判断大小，超大就报错，并执行下一条
                if (item.size > (uploadConfig && uploadConfig.maxSize ? 1024 * uploadConfig.maxSize : 1024 * this.maxSize)) {
                    let errorTip = '[' + item.name + ']文件大小超过' + this.showMaxSize((uploadConfig && uploadConfig.maxSize || this.maxSize));
                    this.fails.push({ 'status': 'fail', 'errMsg': errorTip, 'errType': 'over_max_size', file: item });

                    continue;
                }
                // 判断数量，超量就报错，并停止执行
                if (this.fileList.length >= this.limit) {
                    let errorTip = '文件数量不能超过' + this.limit + '个';
                    this.fails.push({ 'status': 'fail', 'errMsg': errorTip, 'errType': 'over_max_limit', file: item });
                    break;
                }

                /*
                // 在列表中找不到相同文件加入
                getMd5(item).then(md5 => {
                    if (that.fileList.findIndex((one) => { return one.md5 !== md5; }) !== -1) {
                        that.fileList.push({ rawFile: item, url: '', md5: '', status: 'ready', progress: 0, downUrl: '', errMsg: '', result: {} });
                    }
                });
                */

                if (uploadConfig) {
                    auth = typeof uploadConfig.auth !== 'undefined' ? uploadConfig.auth : true;
                }

                // 把所选文件都加入列表
                let options = {
                    onSucc: this.onSucc,
                    onFail: this.onFail,
                    uploadModeType: this.uploadModeType,
                    multimedia: this.multimedia,
                    auth: auth,
                };
                that.fileList.push({ rawFile: item, url: '', md5: '', status: 'ready', progress: 0, downUrl: '', errMsg: '', result: {}, options: options });
            }
            this.$refs.input.value = null;
        },
        handleClick () {
            this.$refs.input.click();
        },
        handleChange (e) {
            let files = e.target.files;
            this.fails = [];
            if (!files) return;

            let upFiles = Array.prototype.slice.call(files);
            if (upFiles.length === 0) { return; }
            console.log('handleChange', upFiles, upFiles[0].name);
            this.formatFileList(upFiles);
            this.$emit('onChange', upFiles);
            if (this.autoUpload) {
                this.submit();
            }
            if (this.fails.length) {
                this.fails.forEach(item => {
                    this.$emit('onFail', item);
                });
            }
        },
        handleRemove () {
            this.$emit('onChange');
        },
        onSucc (files) {
            this.$emit('onSucc', files);
            console.log('成功', files);
        },
        onFail (files) {
            this.$emit('onFail', files);
            console.log('失败', files);
        },
        // 上传
        submit () {
            let param = { uploadUrl: this.uploadUrl, uploadConfig: this.uploadConfig };
            return uploadQuene(this.fileList, param);
        },
    },

};

</script>

<style lang="scss" scoped>
  .yxp-uploader{
        .btn{
            outline: none;
            &.upload-btn{
                width:80px;
                border: none;
                padding:4px 10px;
                border-radius: 4px;
                cursor: pointer;
                background-color:#2FD095;
                color:#fff;
            }
            &.upload-btn:hover{
                background-color:rgb(28, 151, 106);
            }
        }
        input{
            display:none;
        }
    }
</style>
